var exports = {
  "k": "x93eb46d8--8b2dfe--container",
  "Q": "x93eb46d8--8b2dfe--text",
};

module.exports = exports;
